"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNextState = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/**
 * Get the next accordion state.
 *
 * @param {number} panelIndex Selected panel index
 * @param {(number|number[]|null)} state Expanded panel state
 *
 * @returns {(number|number[]|null)} Next panel state.
 */

var getNextState = function getNextState(panelIndex, state) {
  if (Array.isArray(state)) {
    return state.indexOf(panelIndex) !== -1 ? state.filter(function (value) {
      return value !== panelIndex;
    }) : [].concat((0, _toConsumableArray2.default)(state), [panelIndex]).sort();
  }
  return panelIndex === state ? null : panelIndex;
};
exports.getNextState = getNextState;